/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from "../runtime";
/**
 * Check if a given object implements the ModelSet interface.
 */
export function instanceOfModelSet(value) {
    const isInstance = true;
    return isInstance;
}
export function ModelSetFromJSON(json) {
    return ModelSetFromJSONTyped(json, false);
}
export function ModelSetFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        repetitions: !exists(json, "repetitions") ? undefined : json.repetitions,
        weight: !exists(json, "weight") ? undefined : json.weight,
    };
}
export function ModelSetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        repetitions: value.repetitions,
        weight: value.weight,
    };
}
